module.exports = __webpack_public_path__ + "media/blink.a8b74451.mp3";